
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/for-sellers",
      function () {
        return require("private-next-pages/faq/for-sellers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/for-sellers"])
      });
    }
  